import { render, staticRenderFns } from "./ChangePricePerKv.vue?vue&type=template&id=3f346675&"
import script from "./ChangePricePerKv.vue?vue&type=script&lang=js&"
export * from "./ChangePricePerKv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports